import { ExtensionApi } from '../core/extension';

// 定义动画类型与insight类型的映射关系
const ANIMATION_TYPE_MAPPING = {
  AFTG: 'OverallTrend',
  SFTG: 'Trend',
  PFTGTA: 'Trend',
  PFIGTA: 'Trend',
  SFIGTA: 'Trend',
  YILA: 'Interval',
  PFRGTA: 'CompareLine',
  SFRGTA: 'CompareLine',
  PFPGTA: 'ComparePoint',
  SFPGTA: 'ComparePoint',
  SFLA: 'PointCircle',
  PF: 'Highlight',
  SF: 'Highlight',
  SFTA: 'Point',
  PFTA: 'Point',
  RG: 'Line'
};
// 动画时长
const DEFAULT_ANIMATION_DURATION = 1000;

export function convertInsightType(api: ExtensionApi) {
  const { dvInsight } = api.spec.view.main as ExtensionApi['spec']['view']['main'] & {
    dvInsight?: {
      type: string;
      animationDuration?: number;
      animationEffect?: keyof typeof ANIMATION_TYPE_MAPPING;
    }[];
  };
  if (!dvInsight) {
    return;
  }

  const convertedInsight = dvInsight.map(insight => {
    if (!insight.animationEffect) {
      return insight;
    }

    const { type, animationEffect, animationDuration, ...rest } = insight;
    const converted: {
      type?: string;
      linkLegend: boolean;
      animationDuration?: number;
    } = {
      ...rest,
      /** 联动图例（同步弱化） */
      linkLegend: true
    };
    const mappedType = ANIMATION_TYPE_MAPPING[animationEffect];

    // 如果找到对应的映射关系,设置converted的type
    if (!mappedType) {
      throw new Error('No corresponding animation type found');
    }
    converted.type = mappedType;
    // 默认动画时常1s
    converted.animationDuration = animationDuration || DEFAULT_ANIMATION_DURATION;
    return converted;
  });

  // eslint-disable-next-line no-param-reassign
  api.spec.view.main.dvInsight = convertedInsight;
}
